import config from './config';
import { dataReturn } from './utils';

const URL_BASE = config.hostApiTalent;

// const token = sessionStorage.getItem('token');

export async function SignIn(username, password) {
  const API_URL = `${URL_BASE}/signIn`;
  const requestOptions = {
    method: 'POST',
    body: JSON.stringify({ username, password }),
  };
  const resp = await fetch(API_URL, requestOptions);
  const data = await resp.json();
  return dataReturn(resp, data);
}

export async function ChangePasswordFirst(username, newPassword, session) {
  const API_URL = `${URL_BASE}/changePassword1rst`;
  const requestOptions = {
    method: 'POST',
    body: JSON.stringify({ username, newPassword, session }),
  };
  const resp = await fetch(API_URL, requestOptions);
  const data = await resp.json();
  return dataReturn(resp, data);
}

export async function ResetPassword(username) {
  const API_URL = `${URL_BASE}/resetPassword`;
  const requestOptions = {
    method: 'POST',
    body: JSON.stringify({ username }),
  };
  const resp = await fetch(API_URL, requestOptions);
  const data = await resp.json();
  return dataReturn(resp, data);
}

export async function ConfirmationCodePassword(username, code, password) {
  const API_URL = `${URL_BASE}/confirmCode`;
  const requestOptions = {
    method: 'POST',
    body: JSON.stringify({ username, code, password }),
  };
  const resp = await fetch(API_URL, requestOptions);
  const data = await resp.json();
  return dataReturn(resp, data);
}

export async function GetDataUserByUsername(username) {
  const API_URL = `${URL_BASE}/users/${username}`;
  const requestOptions = {
    method: 'GET',
  };
  const resp = await fetch(API_URL, requestOptions);
  const data = await resp.json();
  return dataReturn(resp, data);
}
